export enum INFORM_SOURCE_TYPES {
    YOUTUBE = 'youtube'
}
